import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import 'aos/dist/aos.css';
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import {
    BrowserRouter as Router,
  } from 'react-router-dom';

// Create root using ReactDOM.createRoot()
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render the app inside the root element
root.render(
    <Router>  
        <App/>
    </Router>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
